import {useCallback} from 'react'
import useOcapiSite from '../../hooks/useOcapiSite'
import logger from '../../utils/logger-instance'

/**
 * Creates GOOGLE address validation hook.
 * @returns callback that is going to execute request for address validation
 */
const useAddressValidator = () => {
    const ocapiSite = useOcapiSite()
    const googleKey = ocapiSite?.preferences?.googleMapsApiKey

    return useCallback(
        async (body) => {
            if (!googleKey) {
                logger.warn('Cannot execute address validation without GOOGLE key')
                return null
            }

            if (!body) {
                logger.warn('Cannot validate missing address')
                return null
            }

            const result = await fetch(
                `https://addressvalidation.googleapis.com/v1:validateAddress?key=${googleKey}`,
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(body)
                }
            )
            if (!result?.ok) {
                logger.warn('Validation failed', result?.status)
                return null
            }
            return await result.json()
        },
        [googleKey]
    )
}

export default useAddressValidator
